import { render, staticRenderFns } from "./TipoIncidenciasNom.vue?vue&type=template&id=8b6b93c4&scoped=true"
import script from "./TipoIncidenciasNom.vue?vue&type=script&lang=js"
export * from "./TipoIncidenciasNom.vue?vue&type=script&lang=js"
import style0 from "./TipoIncidenciasNom.vue?vue&type=style&index=0&id=8b6b93c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6b93c4",
  null
  
)

export default component.exports